import { v4 as uuidv4 } from 'uuid'
import { getCookie, setCookie } from './browserCookies'
import { TRACK_UUID_COOKIE_NAME } from '../constants/application'

export const getTrackUuid = () => {
  const oldTrackUuid = getCookie(TRACK_UUID_COOKIE_NAME)

  if (!oldTrackUuid) {
    const newTrackUuid = uuidv4()
    setCookie(TRACK_UUID_COOKIE_NAME, newTrackUuid)
    return newTrackUuid
  }
  return oldTrackUuid
}

// Initialize analytics functions
export const initializeAnalytics = () => {
  let identify = console.log
  let page = console.log
  let track = console.log
  let alias = console.log
  let group = console.log
  let debug = console.log

  let Analytics = {
    identify,
    page,
    track,
    alias,
    group,
    debug
  }

  if (window.analytics) {
    const trackUuid = getTrackUuid()
    if (trackUuid) {
      window.analytics.setAnonymousId(trackUuid)
    }

    identify = (...props) => window.analytics.identify(...props)
    page = (...props) => window.analytics.page(...props)
    track = (...props) => window.analytics.track(...props)
    alias = (...props) => window.analytics.alias(...props)
    group = (...props) => window.analytics.group(...props)
    debug = (...props) => window.analytics.debug(...props)
    Analytics = window.analytics
  } else {
    console.log('window analytics not initialized')
  }

  return {
    ...Analytics,
    identify,
    page,
    track,
    alias,
    group,
    debug
  }
}

// Export initialized analytics
export default initializeAnalytics()
